import { useQuery } from '@tanstack/react-query';

import { type ReproduceSearchParams, getSearchImpressions } from '~/services/ReproduceSearchService';

import { reproduceSearchQueryKeys } from './reproduceSearchQueryKeys';

export function useReproduceSearchImpressions(params: ReproduceSearchParams | null) {
  return useQuery({
    queryKey: reproduceSearchQueryKeys.impressions(params ?? { startDate: '', endDate: '', searchId: '' }),
    queryFn: async ({ signal }) => {
      return await getSearchImpressions(params!, { signal });
    },
    enabled: params !== null,
    retry: false,
  });
}
